import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {RoutingInterfaceApiService} from '../../../../services/api/network/online/routing-interface/routing-interface-api.service';
import {DataCacheApiService} from '../../../services/map/data-cache-api/data-cache-api.service';
import * as _ from 'lodash';

@Component({
  selector: 'offline-connection-summary',
  templateUrl: './offline-connection-summary.component.html',
  styleUrls: ['./offline-connection-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class OfflineConnectionSummaryComponent implements OnInit {

  @Input()
  set selection(selection: any) {
   this.dataInitialization(selection);
  }

  constructor(private nodeApiService: NodeApiService,
              private routingInterfacesApiService: RoutingInterfaceApiService,
              private dataCacheApiService: DataCacheApiService) {
  }

  connection: any;
  isQualityEnabled: boolean;
  dataReady = false;
  ipProfiles = [];
  mediaRealm = [];

  ngOnInit(): void {

    this.dataCacheApiService.getDataReady().subscribe(x => {
      if (x === true) {
        this.dataReady = true;
        this.ipProfiles = this.dataCacheApiService.getIpProfiles();
        this.mediaRealm = this.dataCacheApiService.getMediaRealm();
        this.initializeQualityBasedRoutingConfigurations();
      }
    });
  }

  initializeQualityBasedRoutingConfigurations(): void {
    this.isQualityEnabled = this.dataCacheApiService.getQualityBasedRouting().isQualityEnabled;
  }

  isEmptyArray(item: any): boolean {
    return _.isArray(item) && item.length > 0;
  }

  addIpProfilesData(): void {
    if (this.isEmptyArray(this.ipProfiles)) {
      if (!_.isNil(this.connection.connections[0])) {
        const ipProfileSrc = this.ipProfiles.find(ipProfile =>
            ipProfile.id === this.connection.connections[0].ipProfileId);
        this.connection.connections[0].ipProfileName = ipProfileSrc ? ipProfileSrc.name : '';
      }

      if (!_.isNil(this.connection.connections[1])) {
        const ipProfileDest = this.ipProfiles.find(ipProfile =>
            ipProfile.id === this.connection.connections[1].ipProfileId);
        this.connection.connections[1].ipProfileName = ipProfileDest ? ipProfileDest.name : '';
      }
    }
  }

  private dataInitialization(selection: any): void {
    if (_.isNil(selection)) { return; }

    const shapes = selection.nodes;
    const connections = selection.edges;

    if (shapes.length === 0 && connections.length === 1 && connections[0].connectionType === 'connection') {
      this.connection = connections[0].dataItem;
      this.connection.operState = this.connection.connections[0].operState === 'UNAVAILABLE' ||
      (this.connection.connections.length === 2 && this.connection.connections[1].operState === 'UNAVAILABLE') ? 'UNAVAILABLE' :
        'AVAILABLE';

      this.routingInterfacesApiService.getRoutingInterface(this.connection.connections[0].srcRoutingInterface)
        .then(fetchedRoutingInterface => {
          this.connection.connections[0].srcRoutingInterfaceName = fetchedRoutingInterface.operativeState === 'PREDELETED' ?
            fetchedRoutingInterface.name + ' (PREDELETED)' : fetchedRoutingInterface.name;
        });

      this.nodeApiService.getNode(this.connection.connections[0].srcNodeId).then(fetchedNode => {
        this.connection.connections[0].srcNodeName = fetchedNode.name;
      });

      if (this.connection.type !== 'NODE_TO_THIRD_PARTY') {
        this.routingInterfacesApiService.getRoutingInterface(this.connection.connections[1].srcRoutingInterface)
          .then(fetchedRoutingInterface => {
            this.connection.connections[1].srcRoutingInterfaceName = fetchedRoutingInterface.operativeState === 'PREDELETED' ?
              fetchedRoutingInterface.name + ' (PREDELETED)' : fetchedRoutingInterface.name;
          });

        this.nodeApiService.getNode(this.connection.connections[1].srcNodeId).then(fetchedNode => {
          this.connection.connections[1].srcNodeName = fetchedNode.name;
        });
      }

      this.addIpProfilesData();
    }
  }
}
